var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiTimeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 0a6 6 0 1 0 6 6 6.018 6.018 0 0 0-6-6Zm3 6.75H6A.75.75 0 0 1 5.25 6V3a.75.75 0 0 1 1.5 0v2.25H9a.75.75 0 1 1 0 1.5Z"
})));
export default SvgHaidiTimeIcon;